module.exports = __webpack_public_path__ + "static/img/jf4.23586e72.png";